import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateMember, Member } from "@/model";
import memberRepository from "@/repository/memberRepository";
import { permissionQueryKeys } from "@/query/permission";
import { memberQueryKeys } from "./keys";


export const useCreateMember = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation<Member, AxiosError, CreateMember>({
        mutationKey: ["member", "create"],
        mutationFn: async (form: CreateMember) => {
            try {
                const { data } = await memberRepository.create(scenarioId, form);
                return data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.refetchQueries({ queryKey: permissionQueryKeys.me(scenarioId) }),
                queryClient.invalidateQueries({ queryKey: memberQueryKeys.all(scenarioId) })
            ]);
        }
    });
};
